import axios from "axios";
import Utils from "./Utils";

let userDetail = Utils.getUserDetail();
// const axiosInstance = axios.create({
//   baseURL:
//     window.location.hostname == "localhost"
//       ? "https://platform.dev.hireplusplus.com"
//       : window.location.origin,
//   headers: {
//     ...(userDetail && {
//       Authorization: "Bearer " + userDetail.accessToken,
//       username: "abcd",
//       userIdentifier: userDetail.userIdentifier,
//     }),
//   },
// });

function getCurrentFormattedTime() {
  const now = new Date();

  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0"); // Months are zero-based, so add 1
  const day = String(now.getDate()).padStart(2, "0");

  const hours = String(now.getHours()).padStart(2, "0");
  const minutes = String(now.getMinutes()).padStart(2, "0");
  const seconds = String(now.getSeconds()).padStart(2, "0");

  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
}

// Add an interceptor to handle 401 Unauthorized responses
// axios.interceptors.response.use(
//   (response) => {
//     return response;
//   },
//   (error) => {
//     if (error.response && error.response.status === 401) {
//       window.location.href = '/';
//     }
//     return Promise.reject(error);
//   }
// );

const setHeaderParams = () => {
  let userDetail = Utils.getUserDetail();
  if (userDetail) {
    axios.defaults.headers.common = {
      authorization: "Bearer " + userDetail.accessToken,
      username: "abcd",
      userId: userDetail.userIdentifier,
    };
  }
};
const setHeaderParamsClientId = () => {
  let userDetail = Utils.getUserDetail();
  let userClient = sessionStorage.getItem("clientIdHeader");
  if (userDetail && userClient) {
    axios.defaults.headers.common = {
      authorization: "Bearer " + userDetail.accessToken,
      username: "abcd",
      userId: userDetail.userIdentifier,
      clientId: userClient,
    };
  }
};

const WebUtils = {
  httpOperations: (
    url,
    data,
    httpMethod = undefined,
    noAuth = false,
    responseType = undefined   
  ) => {
    setHeaderParams();

    if (noAuth) {
      delete axios.defaults.headers.common.username;
      delete axios.defaults.headers.common.userId;
      delete axios.defaults.headers.common.authorization;
    }

    if (httpMethod === "GET") {
      return axios.get(url, { params: data }).then(
        (success) => Promise.resolve(success),
        (error) => Promise.reject(error)
      );
    } else if (httpMethod === "DELETE") {
      return axios.delete(url, { data }).then(
        (success) => Promise.resolve(success),
        (error) => Promise.reject(error)
      );
    } else if (httpMethod === "POST" && responseType !== "formData") {
      return axios.post(url, data).then(
        (success) => Promise.resolve(success),
        (error) => Promise.reject(error)
      );
    } else if (httpMethod === "POST" && responseType === "formData") {
      return axios
        .post(url, data, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(
          (success) => Promise.resolve(success),
          (error) => Promise.reject(error)
        );
    } else if (httpMethod === "PUT") {
      return axios.put(url, data).then(
        (success) => Promise.resolve(success),
        (error) => Promise.reject(error)
      );
    }
  },
  httpOperationsHeader: (
    url,
    data,
    httpMethod = undefined,
    responseType = undefined,
    noAuth = false
  ) => {
    setHeaderParamsClientId();

    if (noAuth) {
      delete axios.defaults.headers.common.username;
      delete axios.defaults.headers.common.userId;
      delete axios.defaults.headers.common.authorization;
    }

    // console.log(data)
    if (httpMethod === "GET") {
      return axios.get(url, { params: data }).then(
        (success) => Promise.resolve(success),
        (error) => Promise.reject(error)
      );
    } else if (httpMethod === "DELETE") {
      return axios.delete(url, { data }).then(
        (success) => Promise.resolve(success),
        (error) => Promise.reject(error)
      );
    } else if (httpMethod === "POST" && responseType !== "formData") {
      return axios.post(url, data).then(
        (success) => Promise.resolve(success),
        (error) => Promise.reject(error)
      );
    } else if (httpMethod === "POST" && responseType === "formData") {
      return axios
        .post(url, data, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(
          (success) => Promise.resolve(success),
          (error) => Promise.reject(error)
        );
    } else if (httpMethod === "PUT") {
      return axios.put(url, data).then(
        (success) => Promise.resolve(success),
        (error) => Promise.reject(error)
      );
    }
  },
  getAiInterviewBaseUrl: () => {
    if (window.location.hostname === "localhost") {
      return "https://ai-interview.dev.hireplusplus.com";
    } else {
      return window.location.origin;
    }
  },
  getHireBaseUrl: () => {
    if (
      window.location.hostname === "localhost" ||
      window.location.hostname === "platform.dev.hireplusplus.com"
    ) {
      return "https://dev.hireplusplus.com";
    } else {
      return "https://hireplusplus.com";
    }
  },
  logData : () => {
    const osType = Utils.detectOS();
    const osVersion =Utils.getOSVersion();
    const browserType =Utils.browserCheck();
    const browserVersion =Utils.browserVersionCheck();
    const systemSpecs = Utils.getSystemSpecs();
    const dateTimeInfo = Utils.getDateTimeInfo();
    const logs = {
      osType,
      osVersion,
      browserType,
      browserVersion,
      systemSpecs,
      dateTimeInfo,
    };
    return logs;
  },
};

export default WebUtils;
